import './configure-promise-queue';
import './error-logger';
import './error-test';
import './globals';
import './init-analytics';
import './intl-polyfill';
import './live-updater';
import './load-gapi';
import './monkey-patch-jquery';
import './pinocchio';
import './safari-tab-index';
import './subscriber';
import './token-watcher';
import './update-announcements';
import './vendor-patches';
import './window-resize-watcher';



// WEBPACK FOOTER //
// ./app/scripts/init/index.js